"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
const TwitterShareButton = _ref => {
  let href = _ref.href,
    text = _ref.text,
    intl = _ref.intl;
  const handleClick = () => {
    // Optional Query params
    // via: twitter user to associate with the tweet
    // related: additional users related to the tweet comma-separated
    // hashtags: comma-separated list without #
    window.open("https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(text), "&url=").concat(href), intl.formatMessage({
      id: 'share.components--twitter-share-button.text',
      defaultMessage: 'Compartilhar no Twitter'
    }), 'width=800,height=600');
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "btn white h3 p3 col-12 caps h5 rounded",
    onClick: handleClick,
    style: {
      backgroundColor: '#3DD1F4'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "share.components--twitter-share-button.text",
    defaultMessage: "Compartilhar no Twitter"
  }));
};
var _default = exports.default = (0, _reactIntl.injectIntl)(TwitterShareButton);